export const CHECK_LABELS: Record<string, string> = {
    SUM_REV_TO_PNL: "Revenue totals tie to P&L report",
    SUM_EXP_TO_PNL: "Expense totals tie to P&L report",
    CF_BANK_OPENING_TIE: "Opening cash ties to bank summary",
    CF_BANK_SUMMARY_TIE: "Closing cash ties to bank summary",
    RECON_REVENUE: "Revenue classification reconciles",
    RECON_COGS: "Cost of Sales classification reconciles",
    RECON_EXPENSES: "Operating Expenses classification reconciles",
    LEDGER_PNL_ACCOUNT_TIE: "P&L account totals tie to ledger",
    MONTH_PNL_TIE: "Monthly P&L ties across periods",
    LEDGER_CF_DIRECT_RECON: "Cash flow reconciles to ledger",
    LEDGER_CF_BANK_TIE: "Cash flow ties to bank ledger",
    BS_BALANCE_CHECK: "Balance sheet balances (A = L + E)",
    PNL_ACCOUNT_TIE: "P&L accounts tie to report",
    CF_BANK_TIE: "Cash flow ties to bank report",
    DATA_FRESHNESS: "Xero data is recent (synced within 24h)",
    MAPPING_COVERAGE: "All accounts are mapped to model categories",
    MISSING_PERIODS: "No gaps in monthly journal data",
    SRC_PAGINATION_COMPLETE: "All journal pages retrieved from Xero",
    SRC_PULL_INTEGRITY: "Synced journal totals match Xero report",
};

/** Check group definitions for TrustStrip categories — 4 analyst groups. */
export const CHECK_GROUPS: Record<string, { label: string; checkIds: string[] }> = {
    statement_tieout: {
        label: "Statement Tie-Out",
        checkIds: ["SUM_REV_TO_PNL", "SUM_EXP_TO_PNL", "LEDGER_PNL_ACCOUNT_TIE", "MONTH_PNL_TIE", "PNL_ACCOUNT_TIE", "BS_BALANCE_CHECK"],
    },
    cash_reconciliation: {
        label: "Cash Reconciliation",
        checkIds: ["CF_BANK_OPENING_TIE", "CF_BANK_SUMMARY_TIE", "LEDGER_CF_DIRECT_RECON", "LEDGER_CF_BANK_TIE", "CF_BANK_TIE"],
    },
    classification: {
        label: "Classification",
        checkIds: ["RECON_REVENUE", "RECON_COGS", "RECON_EXPENSES"],
    },
    data_freshness: {
        label: "Data Freshness",
        checkIds: ["DATA_FRESHNESS", "MAPPING_COVERAGE", "MISSING_PERIODS", "SRC_PAGINATION_COMPLETE", "SRC_PULL_INTEGRITY"],
    },
};

/** Which check groups are relevant per tab scope. */
export const TAB_CHECK_GROUPS: Record<string, string[]> = {
    pnl: ["statement_tieout", "classification"],
    cashflow: ["cash_reconciliation"],
    bs: ["statement_tieout"],
    bs_summary: ["statement_tieout"],
    summary: ["statement_tieout", "cash_reconciliation", "classification", "data_freshness"],
    ceo_summary: ["statement_tieout", "cash_reconciliation", "classification", "data_freshness"],
};

export const VARIANCE_TYPE_LABELS: Record<string, string> = {
    match: "Match",
    amount_diff: "Amount Difference",
    reclassification: "Reclassification",
    missing_in_model: "Missing in Model",
    missing_in_xero: "Missing in Xero",
    timing: "Timing Difference",
    other: "Other",
};

export function displayCheckLabel(checkId: string): string {
    return CHECK_LABELS[checkId] ?? checkId;
}
